








import {Vue, Component} from 'vue-property-decorator';
import AppLink from '@/components/AppLink.vue';

@Component({
    name: 'AppFooter',
    components: {AppLink},
})
export default class AppFooter extends Vue {

}
